<template>
  <div class="leave-list">
    <el-table :data="leaveList" border style="width: 100%" tooltip-effect="dark" class="common-edit-button">
      <el-table-column prop="studentNumber" width="120px" :show-overflow-tooltip="true" label="学号">
      </el-table-column>
      <el-table-column prop="studentName" width="120px" :show-overflow-tooltip="true" label="姓名">
      </el-table-column>
      <el-table-column width="100px" label="请假类型">
        <template slot-scope="scope">
          {{ getLeaveType(scope.row.leaveType) }}
        </template>
      </el-table-column>
      <el-table-column prop="startTime" width="160px" label="开始时间"> </el-table-column>
      <el-table-column prop="endTime" width="160px" label="结束时间"> </el-table-column>
      <el-table-column prop="createTime" width="160px" label="申请时间"> </el-table-column>
      <el-table-column prop="content" label="请假原因" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" :width="leaveStatus == 1 ? '220px' : '90px'" fixed="right">
        <template slot-scope="scope">
          <div class="operate">
            <!-- 修改 -->
            <el-button type="success" size="small" @click="showDetail(scope.row.id)">详情</el-button>
            <!-- 审核 -->
            <el-button type="primary" size="small" v-show="scope.row.status == 1 && scope.row.isPass != '已审核'" @click="showDialog(scope.row)"
              v-hasPermi="'sc:leave:edit'">审核
            </el-button>
            <!-- 同意 -->
            <!-- <el-button v-show="scope.row.status == 1" type="success" size="small" @click="updateStatus(scope.row, 2)"
              v-hasPermi="'sc:leave:edit'">同意</el-button> -->
            <!-- 删除 -->
            <!-- <el-button v-show="scope.row.status == 1" type="danger" size="small" @click="updateStatus(scope.row, 3)"
              v-hasPermi="'sc:leave:edit'">拒绝</el-button> -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 审核 -->
    <el-dialog title="审核操作" :visible.sync="dialogFormVisible" v-if="dialogFormVisible" center width="30%">
      <el-form :model="form">
        <el-form-item label="审核操作">
          <el-radio v-model="form.status" label="2">同意</el-radio>
          <el-radio v-model="form.status" label="3">拒绝</el-radio>
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.feedback">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateStatus">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    leaveList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    leaveStatus: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      leaveData: null,
      form: {
        status: "2",
        feedback: "",
      }
    };
  },
  methods: {
    showDialog(row) {
      this.form = {
        status: "2",
        feedback: "",
      };
      this.dialogFormVisible = true;
      this.leaveData = row;
    },
    getLeaveType(leaveType) {
      switch (parseInt(leaveType)) {
        case 1:
          return "事假";
        case 2:
          return "病假";
        case 3:
          return "休学";
        case 4:
          return "其他";
      }
    },
    updateStatus() {
      // 修改学生请假状态 status:2同意 3拒绝
      this.post(this.$url.updateLeaveRecordStatus, {
        id: this.leaveData.id,
        status: this.form.status,
        updateBy: this.user.id,
        requestCode: this.leaveData.requestCode,
        startTime: this.leaveData.startTime,
        endTime: this.leaveData.endTime,
        feedback: this.form.feedback
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$emit("updateStatus", this.leaveData.id);
            this.$message.success("操作成功");
            this.dialogFormVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          this.$message.error("操作失败，请稍后重试");
        });
    },
    // 显示详情
    showDetail(id) {
      // console.log(this.$eventBus);
      this.$eventBus.$emit("showDetail", id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./leave-list.scss";
</style>
